import { TileIndex } from "../../types";

export const RUN_LEVEL_1: TileIndex[][] = [
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 15, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 2, 0, 0, 0, 0, 29, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 2, 0, 0, 0, 0, 29, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 29, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 29, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 29, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 29, 29, 0, 0, 0, 0, 2, 0, 0, 0, 0, 29, 29, 0, 0,
    0, 0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 2, 0, 0, 0, 0, 29, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 2, 0, 0, 0, 0, 29, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 1, 20, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 1, 20, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 1, 20, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 1, 20, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 1, 20, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 12, 1, 20, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1,
  ],
  [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1,
  ],
];
